import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentBanner"] */ "/vercel/path0/components/ConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalPlayerProvider"] */ "/vercel/path0/components/GlobalPlayerProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
